import ShopResultItem from 'components/ShopResultItem/ShopResultItem';
import React from 'react';
import { Pagination } from '@trustedshops/tps-seo-shared-frontend-react-components';
import KeywordList from './KeywordList/KeywordList';
import {
  PaginationWrapper,
  ShopResultList as ShopResultListStyled
} from './ShopResultList.styles';
import { FindMoreTitle } from './FindMoreTitle.styles';
import { ShopResultListProps } from 'models/ShopResultListProps';
import { FormattedMessage, useIntl } from 'react-intl';
import SearchOptions from 'components/SearchOptions/SearchOptions';
import { Divider } from 'components/Divider/Divider.styles';
import { buildHref } from 'helpers/buildHref';
import { PAGE_NUMBER } from 'services/data-test-attributes';

const ShopResultList = ({
  shops,
  keywords,
  pageCount,
  activeFilters
}: ShopResultListProps) => {
  const { formatMessage } = useIntl();
  const shopItems =
    shops &&
    shops.map((shop, index) => (
      <ShopResultItem
        shop={shop}
        embed={activeFilters.embed}
        key={`shop-${shop.tsID}-${index}`}
      />
    ));
  const internationalSearch =
    formatMessage({ id: 'INTERNATIONAL_SEARCH' }) === 'true';
  const displaySearchOptions: boolean = !!activeFilters.q;

  return (
    <ShopResultListStyled>
      {shopItems}
      {keywords && (
        <KeywordList keywords={keywords} activeFilters={activeFilters} />
      )}
      <PaginationWrapper data-test={PAGE_NUMBER}>
        <Pagination
          pageCount={pageCount || 1}
          page={activeFilters.page || 1}
          buildHref={(pageForHref?: number) =>
            buildHref({
              ...activeFilters,
              page: pageForHref
            })
          }
        />
      </PaginationWrapper>
      {internationalSearch && displaySearchOptions && (
        <>
          <Divider />
          <FindMoreTitle>
            <FormattedMessage id="RESULT_LIST.NO_RESULTS.INTERNATIONAL_SEARCH.FIND_MORE" />
          </FindMoreTitle>
          <SearchOptions activeFilters={activeFilters} />
        </>
      )}
    </ShopResultListStyled>
  );
};

export default ShopResultList;
